import React from 'react';
import { Badge } from './Badge';
export function Footer() {
  return <footer className="relative w-full bg-[var(--vu-black)] border-t-2 border-[var(--vu-gold)]/30 py-10 px-5 grain" data-id="element-32" data-mp="3gezcx2w41p0m">
      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center gap-4 text-center" data-id="element-33" data-mp="32oni2w855c5s">
        <Badge size={56} data-id="element-34" data-mp="36oo9rik93jus" />
        <p className="font-display uppercase text-[var(--vu-cream)] text-2xl tracking-wide" data-id="element-35" data-mp="36pzatambadi7">
          Virtually Unknown
        </p>
        <p className="font-cond italic text-[var(--vu-gold)] text-sm" data-id="element-36" data-mp="3ud7iu0b4k0nx">“Old dogs, new tricks”</p>
        <p className="font-body text-[var(--vu-cream)]/40 text-xs" data-id="element-37" data-mp="36d44znhyxod">
          © {new Date().getFullYear()} Virtually Unknown · St. Pete Beach, FL · All rights reserved.
        </p>
      </div>
    </footer>;
}